import { DatePipe } from "@angular/common";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Constants } from "../app.constants";
import { CommonService } from "../common.service";
import { ErrorhandlerService } from "../errorhandler.service";
import { AttendanceConstant } from "./attendance.constant";

@Injectable({
    providedIn: "root"
})

export class AttendanceService{
    constructor(private http: HttpClient,
            private errorHandlerService: ErrorhandlerService,
            private datePipe: DatePipe, 
            private commonService: CommonService){
              //  this.userInfo =this.teamAttendanceUserSubject.asObservable();
            }

    markAttendanceSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    attendanceTypeSubject: BehaviorSubject<any> =  new BehaviorSubject<any>(null);
    teamAttendanceUserSubject: BehaviorSubject<any> =  new BehaviorSubject<any>(null);
    showLeaveApplicationSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    getAttendance(timestamp?){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.ATTENDANCE;
    
        let httpParams = new HttpParams();
        if(timestamp){
            httpParams = httpParams.set("timestamp", timestamp);
        }
        const httpOptions = {
            params: httpParams,
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }

    saveAttendnace(attendnaceData){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.ATTENDANCE;
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.post(url, attendnaceData, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }

    saveLeave(leaveData){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.LEAVE;
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.post(url, leaveData, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }

    getTeamAttendance(timestamp?){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.TEAM_ATTENDANCE;
    
        let httpParams = new HttpParams();
        if(timestamp){
            httpParams = httpParams.set("timestamp", timestamp);
        }
        const httpOptions = {
            params: httpParams,
            observe: 'response' as 'response'
        }
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }
    
    getTeamLeave(){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.LEAVE;
        
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }


    preProcessAttendnaceData(attendance, attendanceTypeMap){
    
            let inTime = attendance.inTimestmap;
            let outTime =  attendance.outTimestamp; 
            let dateTime = attendance.timestamp;
            let totalHours = 0;
            attendance['dateStr'] = "";
            if(dateTime){
                attendance['dateStr'] = this.datePipe.transform(dateTime *1000, 'dd MMM, EEEE');
                attendance['timeForSort'] = dateTime;
            }else if(inTime){
                attendance['dateStr'] = this.datePipe.transform(inTime *1000, 'dd MMM, EEEE');
                attendance['timeForSort'] = inTime;
            }
            attendance['attendanceStr'] = "";
            if(attendance.mark && attendanceTypeMap){
                attendance['attendanceStr'] = attendanceTypeMap[attendance.mark] ? 
                attendanceTypeMap[attendance.mark].name : "";
            }
            attendance['statusStr'] = "";
            if(attendance.status && AttendanceConstant.ATTENDANCE_STATUS_MAP[attendance.status]){
                attendance['statusStr'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[attendance.status].text;
                attendance['statusClass'] = AttendanceConstant.ATTENDANCE_STATUS_MAP[attendance.status].colorClass;
            }
            attendance['remark'] = attendance.remark ? attendance.remark : "";

            attendance['startEndTimingStr'] = "";
            if(inTime ){
                attendance['startEndTimingStr'] = this.datePipe.transform(inTime *1000, 'hh:mm a');
            }
            if(inTime && outTime && (outTime>inTime)){
                attendance['startEndTimingStr'] += " - " + this.datePipe.transform(outTime *1000, 'hh:mm a');
            } 
            if(!inTime && outTime){
                attendance['startEndTimingStr'] =  this.datePipe.transform(outTime *1000, 'hh:mm a');
            } 
            attendance['totalHrsStr'] = "";
            // if(inTime && outTime && outTime > inTime){
            //     let diff =  outTime - inTime;
              
            //     attendance['totalHrsStr'] = this.commonService.getHHMM(diff);
            // }
            if(attendance['attendanceOfDay']){
              
              
                // for(let key of Object.keys(attendance['attendanceOfDay'])){
                //     console.log(key);
                // }
              //  attendance['attendanceOfDay'].forEach(function(value, key){
                  // console.log(attendance['attendanceOfDay'])
                  attendance.attendanceOfDay = attendance.attendanceOfDay.filter(att =>att.inTimestamp!=0 && att.outTimestamp!=0);
                  if(attendance.attendanceOfDay.length>0){
                      let total = 0;
                   for(let obj of  attendance.attendanceOfDay ){
                       if(obj.inTimestmap && obj.outTimestamp){
                        let inTimestamp = this.datePipe.transform(obj.inTimestmap *1000, 'hh:mm a');
                        let outTimestamp = this.datePipe.transform(obj.outTimestamp *1000, 'hh:mm a');
                     
                        obj['attendanceStr'] = inTimestamp+"-"+outTimestamp;
                       }
                      
                   }
                  if(attendance.attendanceOfDay.length>0){
                    attendance.attendanceOfDay.sort(function(x, y){
                        return x.inTimestmap - y.inTimestmap;
                       
                    })
                  }
                
                var maxValue = Math.max(...attendance.attendanceOfDay.map(item => item.outTimestamp));

                var minValue =    Math.min(...attendance.attendanceOfDay.map(item => item.inTimestmap));
           
                let diff = maxValue - minValue;
                if(minValue && maxValue && maxValue > minValue){
                    attendance['totalHrsStr'] = this.commonService.getHHMM(diff)
                }
              
               // console.log(this.commonService.getHHMM(diff))
            }
           // console.log(totalHours);
               // });
            }else{
                if(inTime && outTime && outTime > inTime){
                let diff =  outTime - inTime;
              
                attendance['totalHrsStr'] = this.commonService.getHHMM(diff);
            } 
            }

            
    // console.log(attendance)
        return attendance;
    }


    saveAttendnaceApproval(data){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.ATTENDANCE_APPROVAL;
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.post(url, data, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
  
    }

    getLeaveSummary(timestamp?){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.LEAVE_SUMMARY;
    
        let httpParams = new HttpParams();
        if(timestamp){
            httpParams = httpParams.set("timestamp", timestamp);
        }
        const httpOptions = {
            params: httpParams,
            observe: 'response' as 'response'
        };
        return this.http.get(url, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }
    
    leaveApproval(data){
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.LEAVE_APPROVAL;
        // let param = new  HttpParams();
        // let objectKeys =Object.keys(data);
        // for(let obj of objectKeys){
        //     param = param.append(obj,data[obj])
        // }
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.post(url,data, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }

    saveAttendanceRemark(data){
        
        let url = Constants.ATTENDANCE_BASE_URL + Constants.API_END_POINTS.ATTENDNACE_REMARK;
     
        const httpOptions = {
            observe: 'response' as 'response'
        };
        return this.http.post(url, data, httpOptions).pipe(catchError(this.errorHandlerService.handleError)); 
    }
    
    
}